<template>
    <div class="cpo-event" :class="rootClasses">
        <div class="cpo-event--root">
            <div class="cpo-event--branch cpo-event--branch__label">
                <div class="cpo-event--label">
                    <div class="cpo-event--label-text" v-text="content.title"></div>
                </div>
            </div>
            <div class="cpo-event--trunk">
                <div class="cpo-event--bubble">
                    <cmp-icon v-if="facet === 'end'"
                            class="cpo-event--icon cpo-event--icon__small"
                            symbol="party" size="medium">
                    </cmp-icon>
                    <cmp-icon v-if="facet === 'end'"
                            class="cpo-event--icon cpo-event--icon__large"
                            symbol="party" size="x-large">
                    </cmp-icon>
                </div>
            </div>
            <div class="cpo-event--branch cpo-event--branch__content">
                <!-- <pre v-if="plugin" v-text="plugin"></pre> -->
                <div class="cpo-event--label-text cpo-event--label-text__mobile" v-text="content.title"></div>

                <cmp-accordion
                        facet="cpo-event"
                        :is-active="accordionState"
                        :passive-mode="true"
                        @request-change="updateState($event)">
                    <!-- head -->
                    <template slot="head" slot-scope="props" v-if="content.next_starts && content.next_starts.length > 3">
                        <button class="cpo-event--accordion-head" :class="accordionHeadClasses(props.isActive)">
                            {{ content.toggle_text }}
                            <cmp-icon class="cpo-event--accordion-head-icon"
                                    symbol="chevron_down"
                                    size="x-small">
                            </cmp-icon>
                        </button>
                    </template>

                    <!-- body -->
                    <template slot="body" slot-scope="props">
                        <ul class="u-reset cpo-event--plugins">
                            <li class="cpo-event--plugin cpo-event--date" v-for="startdate in content.next_starts" v-html="startdate"></li>
                        </ul>
                    </template>
                </cmp-accordion>
                <ul class="u-reset cpo-event--plugins">
                    <li class="cpo-event--plugin cpo-event--date" v-if="content.date" v-html="content.date"></li>
                    <li class="cpo-event--plugin" v-for="plugin in plugins">
                        <component :is="plugin.type" :plugin="plugin" :facet="facet"></component>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    import { get } from 'lodash';
    import bemMixin from 'vue/mixins/bem';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
            bemMixin('cpo-event'),
        ],
        props: {
            colorFacet: String,
            event: Object,
            isGlobalFirst: Boolean,
            isGlobalLast: Boolean,
            isFirst: Boolean,
            isLast: Boolean,
            isLight: Boolean,
            isDark: Boolean,
        },
        data() {
            return {
                state: {
                    accordion: false,
                },
            };
        },
        computed: {
            rootClasses() {
                return [
                    this.bemFacet,
                    this.bemAdd(this.colorFacet),
                    this.bemAdd(this.isGlobalFirst ? 'is-global-first' : ''),
                    this.bemAdd(this.isGlobalLast ? 'is-global-last' : ''),
                    this.bemAdd(this.isFirst ? 'is-first' : ''),
                    this.bemAdd(this.isLast ? 'is-last' : ''),
                    this.bemAdd(this.isLight ? 'is-light' : ''),
                    this.bemAdd(this.isDark ? 'is-dark' : ''),
                ];
            },
            eventContent() {
                return get(this.event, 'content', {});
            },
            accordionState() {
                return this.state.accordion;
            },
        },
        methods: {
            accordionHeadClasses(isActive) {
                return [
                    this.bemAdd(isActive ? 'is-active' : '', 'accordion-head'),
                ];
            },
            updateState(updateVal) {
                this.state.accordion = updateVal;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?b7399106